/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IncidentRecordSummaryDto } from './incidentRecordSummaryDto.schema';

export const IReadOnlyListOfIncidentRecordSummaryDto = zod.array(zod.lazy(() => IncidentRecordSummaryDto));

export type IReadOnlyListOfIncidentRecordSummaryDto = zod.input<typeof IReadOnlyListOfIncidentRecordSummaryDto>;
export type IReadOnlyListOfIncidentRecordSummaryDtoOutput = zod.output<typeof IReadOnlyListOfIncidentRecordSummaryDto>;
